module.exports = __webpack_public_path__ + "dist/assets/unsupported.77e71d057201804e549cfb1955359e20.png";